/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { PageDialogStore } from './page-dialog-store';

export const PageDialogContext = createContext<PageDialogStore>(null);
